import { gsap, Power2 } from "gsap/gsap-core";


export class Sun {
    constructor(card_id, card) {
        this.sun = document.querySelector(`#${card_id} .card .sun`);
        this.sun.style.bottom = -this.sun.clientHeight + 'px';
        this.card = card;
    }

    #computeClearPosition(now, sunrise_dt, sunset_dt) {
        const sunriseTimestamp = sunrise_dt;
        const sunsetTimestamp = sunset_dt;
        const middlePosition = (this.card.height / 2 - this.sun.clientHeight / 2);
        const bottomPosition = -this.sun.clientHeight;
        let currentPosition;

        if (now < sunriseTimestamp || now > sunsetTimestamp) {
            currentPosition = bottomPosition;
        } else if (now < sunriseTimestamp + 30 * 60) {
            currentPosition = bottomPosition - (bottomPosition - middlePosition) * (now - sunriseTimestamp) / 30 / 60;
        } else if (now > sunsetTimestamp - 30 * 60) {
            currentPosition = bottomPosition - (bottomPosition - middlePosition) * (sunsetTimestamp - now) / 30 / 60;
        } else {
            currentPosition = middlePosition;
        }
        return currentPosition;
    }

    adjustPosition(weather_type, now, sunrise_dt, sunset_dt) {
        switch (weather_type) {
            case 'sun':
            case 'cloud':
                gsap.to(this.sun.style, {
                    duration: 0,
                    ease: Power2.easeInOut,
                    bottom: this.#computeClearPosition(now, sunrise_dt, sunset_dt) + 'px',
                    onUpdate: () => {
                        let percent_shown = Math.min(1, (this.card.height - this.sun.offsetTop) / this.sun.clientHeight);
                        let coeff = percent_shown**3;
                        this.sun.style.background = `radial-gradient(rgb(255, ${120 + 133 * percent_shown}, ${71 + 147 * percent_shown}) 0%, rgb(247, ${120 + 117 * percent_shown}, 71) 30%, rgba(247, ${120 + 117 * percent_shown}, 71, 0.5) ${40 + 10 * coeff}%, rgba(247, 237, 71, ${0.2 * percent_shown ** 3}) 62%, rgba(247, 237, 71, 0) 70%)`;
                    },
                });
                break;
            default:
                this.sun.style.bottom = -this.sun.clientHeight + 'px';
                break;
        }
    }
}